<template>
  <div class="detailtable" style="width: 100%">
    <div class="row mr-2 ml-2 mt-2">
      <div :class="article.metadatas.length < 7 ? 'col-lg-3' : 'col-lg-6'" v-for="(article, article_index) in data.items" :key="article_index">
        <card class="article-slot">
          <h6 slot="header" class="title">{{article.name}}</h6>
          <p slot="header" class="amount">x{{article.pivot.amount}}</p>
          <span v-if="getTag(article.pivot) === 'Livré'" slot="header" class="state-tag badge badge-pill badge-success">Livré</span>
          <span v-if="getTag(article.pivot) === 'Préparé'" slot="header" class="state-tag badge badge-pill badge-info">Préparé</span>
          <span v-if="getTag(article.pivot) === 'Standby'" slot="header" class="state-tag badge badge-pill badge-warning">Stand-By</span>
          <span v-if="getTag(article.pivot) === 'Sous Traitance'" slot="header" class="state-tag badge badge-pill badge-subcontract">Sous Traitance</span>
          <div  class="row" style="margin-bottom: -5px;">
            <!-- TODO Ajouter du padding top ici  -->
            <div :class="article.metadatas.length < 7 ? 'col-lg-8 pt-2' : 'col-lg-10 pt-2'">
              <div class="article-content row mb-2">

                  <div v-for="(device, device_index) in article.devices" :key="device_index">
                    <p :class="article.metadatas.length < 7 ? 'col-lg-12' : 'col-lg-6'"  v-for="(devicedata, devicedata_index) in device.devicedatas" :key="devicedata_index">
                      <span style="color: #959595">{{devicedata.name+' : '}}</span><span v-show="devicedata.value !== null">{{devicedata.value}}</span>
                    </p>
                  </div>

                  <p v-show="metadata.value !== 'NULL' && metadata.value !== 'Sans'" :class="article.metadatas.length < 7 ? 'col-lg-12' : 'col-lg-6'" v-if="metadata.metadata.options.type !== 'Datetime'" v-for="(metadata, metadata_index) in article.metadatas" :key="metadata_index">
                    <span style="color: #959595">{{metadata.metadata.name}} </span> <span style="font-weight: 500">{{ metadata.value }}</span>
                  </p>
                  <p v-show="metadata.value !== 'NULL'" :class="article.metadatas.length < 7 ? 'col-lg-12' : 'col-lg-6'" v-if="metadata.metadata.options.type == 'Datetime'" v-for="(metadata, metadata_index) in article.metadatas" :key="metadata_index">
                    <span style="color: #959595">{{metadata.metadata.name}} </span><span v-show="metadata.value !== null" style="font-weight: 500">{{ formatDate(metadata.value) }} </span>
                  </p>
                  <div class="col-lg-12" v-if="article.sub_type === 'DEVICE'" style="display: inline-flex">
                    <n-button type="primary" class="btn btn-vr-sm btn-primary" @click.native="openSubscriptionModal(article_index)">
                      <span><i class="fas fa-search"></i></span>
                    </n-button>
                    <p class="ml-2" v-if="article.sub_affected">Abonnement(s):  ({{article.subscriptions.length}}/{{article.pivot.amount}})</p>
                    <p class="ml-2" v-if="!article.sub_affected">Abonnement(s):  ({{article.subscriptions.length}}/{{article.pivot.amount}})</p>
                  </div>
                </div>
            </div>
            <div class="state" :class="article.metadatas.length < 7 ? 'col-lg-4' : 'col-lg-2'">
              <div :title="article.pivot.preparation_date !== null && article.pivot.preparation_date  !== false ? 'Préparé le '+formatDate(article.pivot.preparation_date) : ''" class="article-checkbox">
                <label class="check-label">Préparé</label>
                <div style="margin-right: 10px;float: right;">
                  <n-checkbox style="position: absolute; margin-top: -11px;" v-model="article.pivot.preparation_date"
                              :disabled="(data.items[article_index].pivot.departure_date !== null && data.items[article_index].pivot.departure_date !== false) ||isDisabled(data.canceled)"
                  @input="articlePrepared(article.pivot.id, 'preparation_date', article_index, $event)"></n-checkbox>
                </div>
              </div>
              <div :title="article.pivot.standby_date !== null && article.pivot.standby_date  !== false ? 'Depuis le '+formatDate(article.pivot.standby_date) : ''" class="article-checkbox">
                <label class="check-label">{{standByLabel()}}</label>
                <div style="margin-right: 10px;float: right;">
                  <n-checkbox style="position: absolute; margin-top: -11px;" v-model="article.pivot.standby_date" :disabled="isDisabled(data.canceled)"
                              @input="articlePrepared(article.pivot.id, 'standby_date', article_index, $event)"></n-checkbox>
                </div>
              </div>


              <div :title="article.pivot.departure_date !== null && article.pivot.departure_date  !== false ? 'Livré le '+formatDate(article.pivot.departure_date) : ''" class="article-checkbox">
                <label class="check-label">Livré</label>
                <div style="margin-right: 10px;float: right;">
                  <n-checkbox style="position: absolute; margin-top: -11px;" v-model="article.pivot.departure_date" :disabled="isDisabled(data.canceled)"
                              @input="articlePrepared(article.pivot.id, 'departure_date', article_index, $event)"></n-checkbox>
                </div>
              </div>


              <div :title="article.pivot.subcontract_date !== null && article.pivot.subcontract_date  !== false ? 'Sous traité le '+formatDate(article.pivot.subcontract_date) : ''" class="article-checkbox">
                <label class="check-label">Sous traitance</label>
                <div style="margin-right: 10px;float: right;">
                  <n-checkbox style="position: absolute; margin-top: -11px;" v-model="article.pivot.subcontract_date" :disabled="isDisabled(data.canceled)"
                              @input="articlePrepared(article.pivot.id, 'subcontract_date', article_index, $event)"></n-checkbox>
                </div>
              </div>

            </div>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="subscriptionModal" class="subscription-modal" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">Affectation des abonnements</h4>
      <!-- SyncFusion Tooltip Here -->
      <div class="row">
        <div class="ml-3">
          <label class="input-label">Commandes :</label>
          <fg-input class="select" name="commands">
            <el-select id="commands" placeholder="Choisir une commande" v-model="commandSelect" filterable>
              <el-option v-for="command in commandListOptions" :key="command.id" :label="command.command_number" :value="command.command_number"></el-option>
            </el-select>
          </fg-input>
        </div>
        <div class="ml-3">
          <label class="input-label">Équipements :</label>
          <fg-input class="select" name="devices" v-model="deviceSelect" >
            <el-select id="devices" placeholder="Choisir une équipement" v-model="deviceSelect" filterable multiple collapse-tags>
              <div class="row" style="margin-right: 0px; margin-left: 0px">
                <div class="col-6" style="padding-right: 7px">
                  <n-button  type="primary" class="btn btn-vr-sm btn-primary" style="margin-top: 3px; width: 99%" @click.native="selectAllDevice()">
                    <span style="font-size: 10px">Tous </span>
                  </n-button>
                </div>
                <div class="col-6" style="padding-left: 7px">
                  <n-button  type="primary" class="btn btn-vr-sm btn-primary" style="margin-top: 3px; width: 99%" @click.native="deviceSelect = []">
                    <span style="font-size: 10px">Aucun </span>
                  </n-button>
                </div>
              </div>
              <el-option v-for="device in deviceListOptions" v-if="device.command_number === commandSelect && !suscribedDevices.includes(device.id)" :key="device.id" :label="device.name" :value="device.id">
                <p style="font-size: 11px; margin-top: -6px; font-weight: 600;">{{ device.name }} - {{device.subscription == null ? 'Sans abonnement': endOfSubscription(device.subscription)}}</p>
                <p style="margin-top: -33px; font-size: 10px; font-style: italic;"> {{getSerial(device.metadatas)}}</p>
              </el-option>
            </el-select>
          </fg-input>
        </div>
        <div class="ml-3">
            <label class="input-label">Date de d'expiration</label>
            <fg-input name="endDate" class="end-date" v-model="endDate" addon-left-icon="now-ui-icons far fa-calendar-alt">
              <flat-picker ref="endDate" slot-scope="{focus, blur}" :config="flatpickr_config"
                           class="datepicker" :placeholder="'Choisir une date'"
                           v-model="endDate">
              </flat-picker>
            </fg-input>
        </div>
        <div class="ml-3">
          <n-button  :disabled="tableData.length >= data.items[articleIndexSelected].pivot.amount" type="primary" class="btn btn-sm btn-primary" style="margin-top: 7px;" @click.native="addToTableData()">
            <span><i class="fas fa-plus"></i></span>
          </n-button>
        </div>
        <div class="ml-auto mr-3">
          <label class="input-label">Rechercher</label>
          <fg-input placeholder="Recherche"
                    v-model="searchInput"
                    autocomplete="off" name="search"
                    addon-left-icon="fas fa-search">
          </fg-input>
        </div>
      </div>

      <ejs-grid :ref="'subscriptionList - '+data.items[articleIndexSelected]['pivot']['id']"
                :id="'SubscriptionGrid'+data.items[articleIndexSelected]['pivot']['id']"
                :dataSource="tableData" :enablePersistence='false' @actionComplete="refreshRendering"
                :allowReordering='false' :allowResizing='true'  :showColumnChooser='true'
                :enableHover='false' :allowSelection='true' :allowPaging="true" :rowDataBound="rowDataBound"
                :allowSorting='true' :allowGrouping='false'  :editSettings='editSettings'
                :pageSettings='pageSettings' :allowExcelExport='true' class="article-datagrid">
        <e-columns>
          <e-column field='device' :disableHtmlEncode="false" headerText='Équipement' isPrimaryKey=true textAlign='Left' width=80></e-column>
          <e-column field='old_subscription' :disableHtmlEncode="false" headerText='Ancien abonnement' textAlign='Left' width=80></e-column>
          <e-column field='new_subscription' :disableHtmlEncode="false" headerText='Abonnement' textAlign='Left' width=80></e-column>
          <e-column field='commands' :headerText="tableData.length+'/'+data.items[articleIndexSelected].pivot.amount" textAlign='Center' minWidth=20 width=20 :commands='commands'></e-column>
        </e-columns>
      </ejs-grid>

      <template slot="footer">
        <n-button type="primary" class="btn btn-sm btn-primary text-center" @click.native="saveSubscription()"><span><i class="fas fa-save"></i></span></n-button>
      </template>
    </modal>
  </div>
</template>

<script>
// import {Checkbox} from 'src/components'
import {ColumnChooser, CommandColumn, DetailRow, Edit,
  ExcelExport, Filter, Group, Page, Reorder, Resize,
  Search, Sort} from "@syncfusion/ej2-vue-grids";
import Checkbox2 from '../../../components/Inputs/Checkbox2'
import moment from "moment";
import {Modal} from 'src/components'
import { Select, Option } from 'element-ui'
import {French} from "flatpickr/dist/l10n/fr";
import flatPicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {format} from "d3";

export default {
  name: "detailTemplate",
  components: {
    Modal,
    [Checkbox2.name]: Checkbox2,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker
  },
  data() {
    return {
      subscriptionModal: false,

      searchInput: '',

      articleIndexSelected: 0,

      commandSelect: '',
      deviceSelect: [],
      endDate: '',

      commandListOptions: [],
      deviceListOptions: [],

      suscribedDevices: [],
      tableData: [],
      tableLoaded : false,
      editSettings: { allowEditing: false, allowDeleting: true },
      pageSettings: { pageSize: 15, pageSizes: true },
      commands: [{ buttonOption: { cssClass: 'e-flat', iconCss: 'e-icons', click: this.removeSubscriptionButton} }],

      data: {

      },

      flatpickr_config: {
        allowInput: true,
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'd/m/Y',
        altInput: true,
        mode: 'single',
        dateFormat: 'Y-m-d',
        locale: French,
        minDate: null
      },
    };
  },
  provide: {
    grid: [Page, Search, Sort, Filter, Group, ExcelExport, DetailRow, ColumnChooser, Resize, Reorder, Edit, CommandColumn]
  },
  watch: {
    deviceSelect: function(newValue, oldValue){
      var minDate = null
      this.deviceSelect.forEach( (device, index, array) => {
        if(minDate === null){
          minDate = this.endOfSubscription(this.deviceListOptions[device]['subscription'], 'date')
        } else {
          if(minDate < this.endOfSubscription(this.deviceListOptions[device]['subscription'], 'date')){
            minDate = this.endOfSubscription(this.deviceListOptions[device]['subscription'], 'date')
          }
        }
      })

      this.flatpickr_config.minDate = minDate
    },
    commandSelect: function(newValue, oldValue){
      this.deviceSelect = []
    },
    subscriptionModal: function(newValue, oldValue){
      if(newValue === false){
        this.tableData = []
        this.tableLoaded = false
        this.suscribedDevices = []
      } else {
        this.commandSelect = this.data.command_number
      }
    }
  },
  mounted() {
    this.commandUrgentHandler = args => {
      this.data.urgent = args
    }
    this.setCommandListHandler = args => {
      this.commandListOptions = args.result
    }
    this.setDeviceListHandler = args => {
      this.deviceListOptions = args
    }

    EventBus.$on('commandUrgent'+this.data.id, this.commandUrgentHandler)
    EventBus.$on('setCommandList', this.setCommandListHandler)
    EventBus.$on('setDeviceList', this.setDeviceListHandler)

    EventBus.$emit('getCommandList')
  },
  beforeDestroy() {
    EventBus.$off('commandUrgent'+this.data.id, this.commandUrgentHandler)
    EventBus.$off('setCommandList', this.setCommandListHandler)
    EventBus.$off('setDeviceList', this.setDeviceListHandler)
  },
  methods: {
    isDisabled(canceled){
      return window.App.role === 'Commercial' || canceled === 1
    },

    standByLabel(){
      let label = 'En attente'
      // if(this.$route.name === 'Wi-line'){
      //   label = 'Sous-Traitance'
      // }

      return label
    },

    // Retourne le numéro de série a affciher pour idenfier un Device dans le tableau et la liste déroulante
    getSerial(metadatas){
      var serial = ''

      metadatas.forEach( metadata =>{
        if(metadata.name === 'Serial M4' || metadata.name === 'Device EUI'){
          serial = metadata.name+': '+ metadata.value
        }
      })
      return serial
    },
    // Retourne la durée d'abonnement
    getSubscriptionDuration(metadatas){
      var duration = 0

      metadatas.forEach( metadata =>{
        if(metadata.metadata.name === 'Durée'){
          duration = parseInt(metadata.value)
        }
      })
      return duration
    },
    // Affecte un équipement à l'abonnement séléctionné
    addToTableData(){
      var available = this.data.items[this.articleIndexSelected].pivot.amount - this.tableData.length

      if(this.deviceSelect.length > available){
        this.$notify({message: "Vous avez séléctionné "+this.deviceSelect.length+" équipements, et il ne reste que "+available+" abonnements à affectés", type: 'danger', verticalAlign: 'bottom'})
      } else {
        var tableData = [...this.tableData]
        this.tableLoaded = false

        var fillTableData = new Promise((resolve, reject) => {
          this.deviceSelect.forEach( (device, index, array) => {
            this.suscribedDevices.push(device)
            tableData.push(
                {
                  id: 'New',
                  device_id: device,
                  item_id: this.data.items[this.articleIndexSelected]['pivot']['id'],
                  expiration_date: 'expiration_date',
                  device: 'device',
                  old_subscription: 'old_subscription',
                  new_subscription: 'new_subscription',
                }
            )
            if (index === array.length -1) resolve();
          })
        })

        fillTableData.then(() => {
          this.tableData = tableData
          this.deviceSelect = []
        });
      }
    },
    // Retourne la date de fin de l'abonnement (avec la référence de ce dernier)
    endOfSubscription(subscriptions, type = 'string'){
      var last_subscription_date = null
      var ref = ''
      subscriptions.forEach( subscription => {
        if(last_subscription_date === null){
          var subscription_date = moment(subscription.start_date).add(subscription.duration, 'd')
          last_subscription_date = new Date(subscription_date.format('YYYY-MM-DD'))
          ref = subscription.ref
        } else {
          var subscription_date = moment(subscription.start_date).add(subscription.duration, 'd')
          if(new Date(subscription_date.format('YYYY-MM-DD')) > last_subscription_date){
            last_subscription_date = new Date(subscription_date.format('YYYY-MM-DD'))
            ref = subscription.ref
          }
        }
      })

      var date = moment(last_subscription_date)
      if(type === 'date'){
        return new Date(date.format('YYYY-MM-DD'))
      }
      return 'Expire le '+date.format('DD/MM/YYYY')+' ('+ref+')'
    },
    // Sélectionne tous les équipenents dans la liste déroulante
    selectAllDevice(){
      Object.values(this.deviceListOptions).forEach( device => {
        if(device.command_number === this.commandSelect && !this.suscribedDevices.includes(device.id)){
          this.deviceSelect.push(device.id)
        }
      })
    },
    // rowDataBound
    rowDataBound: function (args) {
      var device = this.deviceListOptions[args.data.device_id]
      var old_subscription = 'Sans abonnement';
      var new_subscription = '';
      var subscriptionList = [];

      if(this.deviceListOptions[args.data.device_id].subscription !== null) {
        this.deviceListOptions[args.data.device_id].subscription.forEach(subscription => {
          if (subscription.id === args.data.id) {
            var expirationDate = moment(subscription.start_date).add(subscription.duration, 'd');
            subscription.expiration_date = expirationDate.format('DD/MM/YYYY')
            new_subscription = subscription
          } else {
            var expirationDate = moment(subscription.start_date).add(subscription.duration, 'd');
            subscription.expiration_date = expirationDate.format('DD/MM/YYYY')
            subscription.expiration_date_timestamp = expirationDate.toDate().getTime()

            // var row_expiration_date = moment(args.data.expiration_date).format('YYYY-MM-DD')

            if(moment(args.data.expiration_date, 'DD/MM/YYYY').format('YYYY-MM-DD') !== 'Invalid date'){
              var row_expiration_date = new Date(moment(args.data.expiration_date, 'DD/MM/YYYY').format('YYYY-MM-DD'));
              var sub_expiration_date = new Date(expirationDate.format('YYYY-MM-DD'));
              if(sub_expiration_date < row_expiration_date){
                subscriptionList.push(subscription)
              }
            } else {
              subscriptionList.push(subscription)
            }
          }
        })


        subscriptionList = subscriptionList.sort((a, b) => a.expiration_date_timestamp - b.expiration_date_timestamp)

        if (subscriptionList.length > 0  && args.data.id !== 'New'){
          var old_expiration_date = moment(subscriptionList[subscriptionList.length - 1].expiration_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
          var new_expiration_date = moment(new_subscription.expiration_date, 'DD/MM/YYYY').format('YYYY-MM-DD')

          old_expiration_date = new Date(old_expiration_date)
          new_expiration_date = new Date(new_expiration_date)

          if(old_expiration_date <  new_expiration_date) {
            old_subscription = subscriptionList[subscriptionList.length - 1]
          }
        } else if(subscriptionList.length > 0){
          old_subscription = subscriptionList[subscriptionList.length - 1]
        }

        if (old_subscription !== 'Sans abonnement') {
          if( old_subscription.readjust_from === null){
            args.data.old_subscription = '<p style="font-size: 13px; margin-top: 0px; font-weight: 600;">' + old_subscription.command_number + ' - ' + old_subscription.name + '</p> <p style="margin-top: -17px; margin-bottom: 0; font-size: 12px; font-style: italic;">' + old_subscription.ref + ': Expire le ' + old_subscription.expiration_date + '</p>'
          } else {
            var readjust_from = moment(old_subscription.readjust_from)
            var old_subscription_expiration_date = moment(old_subscription.start_date).add(old_subscription.duration, 'd')
            var diffDays = old_subscription_expiration_date.diff(readjust_from, 'days')

            if(diffDays > 0){
              diffDays = '+ '+diffDays
            }

            args.data.old_subscription = '' +
                '<p style="font-size: 13px; margin-top: 0px; font-weight: 600;">' + old_subscription.command_number + ' - ' + old_subscription.name +
                '</p> <p style="margin-top: -17px; margin-bottom: 0; font-size: 12px; font-style: italic;">'
                + old_subscription.ref + ': Expire le  <span style="text-decoration: line-through">'
                + readjust_from.format('DD/MM/YYYY') + '</span> -> ' + old_subscription.expiration_date + '' +
                ' <span style="color: red; margin-left: 3px">  (' + diffDays + ' jours)</span></p>'
          }
        } else {
          args.data.old_subscription = old_subscription
        }

        if (old_subscription !== 'Sans abonnement' && args.data.id === 'New') {
          var duration = this.getSubscriptionDuration(this.data.items[this.articleIndexSelected]['metadatas'])
          var expirationDate = moment(old_subscription.expiration_date, 'DD/MM/YYYY').add(duration, 'M')

          if (this.endDate !== null && this.endDate !== '' && args.data.readjust_from !== null){
            var a = moment(this.endDate);
            var b = moment(moment(old_subscription.expiration_date, 'DD/MM/YYYY'));
            expirationDate = moment(old_subscription.expiration_date, 'DD/MM/YYYY').add(a.diff(b, 'days'), 'd')

            var c = moment(old_subscription.expiration_date, 'DD/MM/YYYY').add(duration, 'M')
            var d = expirationDate
            var missingDays = d.diff(c, 'days')
          }

          args.data.start_date =  moment(old_subscription.expiration_date, 'DD/MM/YYYY').format('YYYY-MM-DD')

          if(args.data.expiration_date === 'expiration_date'){
            args.data.expiration_date = expirationDate.format('YYYY-MM-DD')
          }

          if(missingDays !== undefined && args.data.readjust_from === undefined){
            args.data.new_subscription = '' +
                '<p style="font-size: 13px; margin-top: 0px; font-weight: 600;">' + this.data.command_number + ' - ' + this.data.items[this.articleIndexSelected]['name'] +
                '</p> <p style="margin-top: -17px; margin-bottom: 0; font-size: 12px; font-style: italic;">'
                + this.data.items[this.articleIndexSelected]['ref'] + ': Expire le  <span style="text-decoration: line-through">'
                + c.format('DD/MM/YYYY') + '</span> -> ' + expirationDate.format('DD/MM/YYYY') + '' +
                ' <span style="color: red; margin-left: 3px">  (' + missingDays + ' jours)</span></p>'

            args.data.readjust_from = c.format('YYYY-MM-DD')
          } else if(args.data.readjust_from === undefined) {
            args.data.readjust_from = null
            args.data.new_subscription = '<p style="font-size: 13px; margin-top: 0px; font-weight: 600;">' + this.data.command_number + ' - ' + this.data.items[this.articleIndexSelected]['name'] + '</p> <p style="margin-top: -17px; margin-bottom: 0; font-size: 12px; font-style: italic;">' + this.data.items[this.articleIndexSelected]['ref'] + ': Expire le ' + expirationDate.format('DD/MM/YYYY') + '</p>'
          }
        } else {
          if(new_subscription.readjust_from !== undefined && new_subscription.readjust_from !== null){

            var date1 = moment(new_subscription.readjust_from)
            var date2 = moment(new_subscription.expiration_date, 'DD/MM/YYYY')
            var diffDays = date2.diff(date1, 'days')

            if(diffDays > 0){
              diffDays = '+ '+diffDays
            }

            args.data.new_subscription = '' +
                '<p style="font-size: 13px; margin-top: 0px; font-weight: 600;">' + this.data.command_number + ' - ' + new_subscription.name +
                '</p> <p style="margin-top: -17px; margin-bottom: 0; font-size: 12px; font-style: italic;">'
                + new_subscription.ref + ': Expire le  <span style="text-decoration: line-through">'
                + moment(new_subscription.readjust_from).format('DD/MM/YYYY') + '</span> -> ' + new_subscription.expiration_date + '' +
                ' <span style="color: red; margin-left: 3px">  (' + diffDays + ' jours)</span></p>'
          } else {
            args.data.new_subscription = '<p style="font-size: 13px; margin-top: 0px; font-weight: 600;">' + this.data.command_number + ' - ' + new_subscription.name + '</p> <p style="margin-top: -17px; margin-bottom: 0; font-size: 12px; font-style: italic;">' + new_subscription.ref + ': Expire le ' + new_subscription.expiration_date + '</p>'
          }
        }

      } else {
        args.data.old_subscription = old_subscription
        var duration = this.getSubscriptionDuration(this.data.items[this.articleIndexSelected]['metadatas'])
        if(old_subscription !== 'Sans abonnement'){
          var expirationDate = moment(old_subscription.expiration_date, 'DD/MM/YYYY').add(duration, 'M')
        } else {

          var expirationDate = moment().add(duration, 'M')

          if (this.endDate !== null && this.endDate !== ''){
            var a = moment(this.endDate);
            var b = moment();
            expirationDate = moment().add(a.diff(b, 'days'), 'd')

            var c = moment().add(duration, 'M')
            var d = expirationDate
            var missingDays = d.diff(c, 'days')
          }

          args.data.start_date =  moment().format('YYYY-MM-DD')

          if(args.data.expiration_date === 'expiration_date'){
            args.data.expiration_date = expirationDate.format('YYYY-MM-DD')
          }

          if(missingDays !== undefined){
            args.data.new_subscription = '' +
                '<p style="font-size: 13px; margin-top: 0px; font-weight: 600;">' + this.data.command_number + ' - ' + this.data.items[this.articleIndexSelected]['name'] +
                '</p> <p style="margin-top: -17px; margin-bottom: 0; font-size: 12px; font-style: italic;">'
                + this.data.items[this.articleIndexSelected]['ref'] + ': Expire le  <span style="text-decoration: line-through">'
                + c.format('DD/MM/YYYY') + '</span> -> ' + expirationDate.format('DD/MM/YYYY') + '' +
                ' <span style="color: red; margin-left: 3px">  (' + missingDays + ' jours)</span></p>'

            args.data.readjust_from = c.format('YYYY-MM-DD')
          } else if(args.data.readjust_from === undefined) {
            args.data.readjust_from = null
            args.data.new_subscription = '<p style="font-size: 13px; margin-top: 0px; font-weight: 600;">' + this.data.command_number + ' - ' + this.data.items[this.articleIndexSelected]['name'] + '</p> <p style="margin-top: -17px; margin-bottom: 0; font-size: 12px; font-style: italic;">' + this.data.items[this.articleIndexSelected]['ref'] + ': Expire le ' + expirationDate.format('DD/MM/YYYY') + '</p>'
          }

        }

        args.data.expiration_date = expirationDate

        new_subscription = {
          name: this.data.items[this.articleIndexSelected]['name'],
          ref: this.data.items[this.articleIndexSelected]['ref'],
          expiration_date: expirationDate
        }

        // args.data.new_subscription = '<p style="font-size: 13px; margin-top: 0px; font-weight: 600;">' + this.data.command_number + ' - ' + new_subscription.name + '</p> <p style="margin-top: -17px; margin-bottom: 0; font-size: 12px; font-style: italic;">' + new_subscription.ref + ': Expire le ' + new_subscription.expiration_date.format('DD/MM/YYYY') + '</p>'
      }

      args.data.device = '<p style="font-size: 13px; margin-top: 0px; font-weight: 600;">'+device.command_number+' - '+device.name+'</p>'+
      '<p style="margin-top: -17px; margin-bottom: 0; font-size: 12px; font-style: italic;">'+this.getSerial(device.metadatas)+'</p>'


      if(args.data.id === 'New'){
        args.row.cells[3].firstElementChild.firstElementChild.firstElementChild.classList = "fas fa-trash-alt"
      } else {
        args.row.cells[3].firstElementChild.innerHTML = ''
      }
    },
    // Supprime l'abonnement d'un équipement
    removeSubscriptionButton: function (args){
      var rowEle = $(args.target).parents('.e-row')
      var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
      this.$refs['subscriptionList - '+this.data.items[this.articleIndexSelected]['pivot']['id']].selectRow(rowIndex)
      var rowData = this.$refs['subscriptionList - '+this.data.items[this.articleIndexSelected]['pivot']['id']].getSelectedRecords()[0]

      const index = this.suscribedDevices.indexOf(rowData.device_id);
      if (index > -1) {
        this.suscribedDevices.splice(index, 1);
      }

      this.$refs['subscriptionList - '+this.data.items[this.articleIndexSelected]['pivot']['id']].deleteRecord('device', rowData.device)
    },
    // Enregistre les abonnements pour les équipements du tableau
    saveSubscription(){
      this.axios.post(process.env.VUE_APP_API_BASE_URL+'subscriptions/update', {
        subscriptions: this.tableData
      }).catch(error => {
        this.$notify({message: "Une erreur est survenue lors de la l\'enregistrement", type: 'danger', verticalAlign: 'bottom'})
      }).then( response => {
        this.subscriptionModal = false
        this.$notify({message: 'Les abonnements ont été mis à jour', type: 'success', verticalAlign: 'bottom'})
        this.data.items[this.articleIndexSelected].subscriptions = response.data.subscriptions
        EventBus.$emit('updateDeviceList' , response.data.subscriptions)
      })
    },
    // Ouvre la modal et charge les équipements déja affecté dans le tableau
    openSubscriptionModal(article_index){
      this.articleIndexSelected = article_index
      this.tableData = [];

      var tableData = [];
      var fillTableData = new Promise((resolve, reject) => {
        this.data.items[article_index].subscriptions.forEach( (subscription, index, array) => {

          var expirationDate = moment(subscription.start_date).add(subscription.duration, 'd')

          this.suscribedDevices.push(subscription.device_id)

          tableData.push({
            id: subscription.id,
            device_id: subscription.device_id,
            item_id:subscription.item_id,
            expiration_date: expirationDate.format('DD/MM/YY'),
            start_date: subscription.start_date,
            duration: subscription.duration,
            readjust_from: subscription.readjust_from
          })

          if (index === array.length -1) resolve();
        })
      })

      fillTableData.then(() => {
        this.tableData = tableData
      });

      this.subscriptionModal = true
    },
    // Permet de recharger le tableau une seconde fois pour le render soit effectif // TODO Faire en sorte de ne pas recharger le tableau une seconde
    refreshRendering: function(args){
      if(this.tableLoaded === false && args.rows !== undefined){
        var tableData = [... this.tableData]
        this.tableData = tableData
        this.tableLoaded = true
      }
    },
    // Retourne l'état de la l'article pour afficher le tag approprié en haut à gauche de l'article
    getTag(articlePivot){
      if(articlePivot.departure_date !== false && articlePivot.departure_date !== null){
        return 'Livré'
      } else if(articlePivot.preparation_date !== false && articlePivot.preparation_date !== null){
        return 'Préparé'
      } else if(articlePivot.standby_date !== false && articlePivot.standby_date !== null){
        return 'Standby'
      } else if(articlePivot.subcontract_date !== false && articlePivot.subcontract_date !== null){
        return 'Sous Traitance'
      } else {
        return 'Autre'
      }
    },
    // Change l'état de l'article et met à jour le style en conséquence
    articlePrepared(item_id, state , article_index, $event){
      if(window.App.role !== 'Commercial') {
        var CommandDeliver = 0
        var CommandPrepared = 0
        var CommandStandBy = 0
        var CommandSubContract = 0

        this.data.items.forEach(item => {
          if(item.pivot.departure_date !== false && item.pivot.departure_date !== null){
            CommandDeliver++
          }

          if(item.pivot.standby_date !== false && item.pivot.standby_date !== null){
            CommandStandBy++
          }

          if(item.pivot.preparation_date !== false && item.pivot.preparation_date !== null){
            CommandPrepared++
          }

          if(item.pivot.subcontract_date !== false && item.pivot.subcontract_date !== null){
            CommandSubContract++
          }
        })

        if($event) {
          if (state === 'departure_date' && (this.data.items[article_index]['pivot']['preparation_date'] === null || this.data.items[article_index]['pivot']['preparation_date'] === false)) {
            this.data.items[article_index]['pivot']['preparation_date'] = moment().format('YYYY-MM-DD')
          }
        }


        if(CommandDeliver === this.data.items.length){
          EventBus.$emit('commandStateUpdate', {state :'departure_date', commandId: this.data.id})
        } else if(CommandPrepared === this.data.items.length) {
          EventBus.$emit('commandStateUpdate', {state :'preparation_date', commandId: this.data.id})
        } else if(CommandStandBy > 0) {
          EventBus.$emit('commandStateUpdate', {state :'standby_date', commandId: this.data.id})
        } else if(CommandSubContract > 0) {
          EventBus.$emit('commandStateUpdate', {state :'subcontract_date', commandId: this.data.id})
        } else {
            if(state === 'preparation_date' && CommandPrepared > 0 &&  CommandPrepared < this.data.items.length){
            EventBus.$emit('commandStateUpdate', {state :'half-prepared', commandId: this.data.id})
          } else {
            EventBus.$emit('commandStateUpdate', {state :'todo', commandId: this.data.id})

          }
        }

        this.axios.get(process.env.VUE_APP_API_BASE_URL+`item/state/update`, {
          params: {
            item_id: item_id,
            state: state,
            $event: $event
          }
        }).then((response) => {
          if($event){
            if(state === 'departure_date' && (this.data.items[article_index]['pivot']['preparation_date'] === null || this.data.items[article_index]['pivot']['preparation_date'] === false) ){
              this.data.items[article_index]['pivot']['preparation_date'] = moment().format('YYYY-MM-DD')
            }
            this.data.items[article_index]['pivot'][state] = moment().format('YYYY-MM-DD')
          } else {
            this.data.items[article_index]['pivot'][state] = false
          }
          EventBus.$emit('refreshFiltersNumbers')
        })
      }
    },
    // Formate une date en 'DD/MM/YY'
    formatDate(date){
      return moment(date).format('DD/MM/YYYY')
    }
  },
};
</script>

<style>
.badge-subcontract {
  border-color: #D90368;
  background-color: #D90368;
}
.check-label{
  overflow: hidden;
  text-overflow: ellipsis;
}

.datepicker {
  height: 40px;
}

.end-date {
  width: 205px;
}

.el-select .el-select__tags .el-tag {
  padding: 0 6px 0 10px;
}
.el-select .el-select__tags .el-tag {
  background-color: #f96332 !important;
}

.subscription-modal .modal-dialog{
  width: 70%;
  margin: 10% auto 15% calc(8% + 260px)!important;
  max-width: unset !important;
}

.subscription-modal .modal-content .modal-header {
  border-bottom: none;
  padding-top: 10px;
  padding-right: 24px;
  padding-bottom: 10px;
  padding-left: 24px;
  border-bottom: 1px solid #e0e0e0;
}

.subscription-modal .modal-content .modal-header button {
  position: absolute;
  right: 27px;
  top: 20px;
  outline: 0;
}

.btn-vr-sm {
  margin-top: -9px;
  height: 17px;

  font-size: 10px;
  border-radius: 0.1875rem;
  padding: 3px 3px;
}
.article-slot {
  background: #FFFFFF;
  border: 1px solid #DBDBDB;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.11);
}
.article-slot .title {
  text-align: center;
  margin-top: -8px;
}
.article-slot .amount {
  float: right;
  right: 10px;
  margin-top: -24px;
}

.state {
  position: absolute;
  right: 0;
  bottom: 3px;
}

.article-slot .article-content p{
  line-height: 0.7;
}

.article-checkbox {
  margin-top: 4px;
  display: flex;
  justify-content: space-between;
}

.article-content {
  min-height: 65px;
  overflow: auto;
  white-space: nowrap;
  padding-top: 5px;
}

.state-tag {
  margin-top: -23px;
  position: absolute;
  width: 20%;
}
</style>
